import React from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';
import Parser from 'html-react-parser';
import Loader from 'react-loader';

class ModalPopup extends React.Component {
    constructor(props) {
        super(props);

        this.onPrimaryButtonClick = this.onPrimaryButtonClick.bind(this);
        this.onPrimaryButtonKeyup = this.onPrimaryButtonKeyup.bind(this);
        this.onCancelButtonClick = this.onCancelButtonClick.bind(this);
        this.onCancelButtonKeyup = this.onCancelButtonKeyup.bind(this);
    }

    onPrimaryButtonClick() {
        this.props.confirm();
    }

    onPrimaryButtonKeyup(e) {
        if (e.keyCode === 13) this.onPrimaryButtonClick();
    }

    onCancelButtonClick() {
        this.props.cancel();
    }

    onCancelButtonKeyup(e) {
        if (e.keyCode === 13) this.onCancelButtonClick();
    }

    render() {
        const body = typeof this.props.body === 'string' ? Parser(this.props.body) : this.props.body;
        return (
            <Modal isOpen={this.props.open} backdrop={true} style={{ maxWidth: (this.props.width || 600) + 'px' }}>
                <ModalHeader>{this.props.title || 'Confirmation'}</ModalHeader>
                <ModalBody>
                    <div className="py-2">{body}</div>
                </ModalBody>
                <ModalFooter className="d-block">
                    <div className="row">
                        <div className="col">
                            <button
                                className="mr-4 btn btn-secondary-new"
                                onClick={this.onCancelButtonClick}
                            >{this.props.buttonCancel}</button>
                        </div>
                        <div className="col text-right">
                            {this.props.hasOwnProperty('loaded') && this.props.buttonConfirm &&
                                <Loader loaded={this.props.loaded} color='#BD2E2A' top="15px" left="calc(100% - 50px)" scale="0.5">
                                    <button
                                        className="btn btn-primary-new"
                                        onClick={this.onPrimaryButtonClick}
                                    >{this.props.buttonConfirm}</button>
                                </Loader>
                            }
                            {!this.props.hasOwnProperty('loaded') && this.props.buttonConfirm &&
                                <button
                                    className="btn btn-primary-new"
                                    onClick={this.onPrimaryButtonClick}
                                >{this.props.buttonConfirm}</button>
                            }
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}
export default ModalPopup;


// WEBPACK FOOTER //
// ./src/components/ModalPopup/ModalPopup.js